<template>
	<div>
		<van-grid :column-num="2" :border="false">
			<van-grid-item text="菜品分类名称" />
			<van-grid-item text="排序值" />
		</van-grid>
		<van-list>
			<van-cell v-for="(item,index) in storeFoodList" :key="index">
				<van-grid :column-num="2" :border="false">
					<van-grid-item :text="item.name" />
					<van-grid-item>
						<input type="text" v-model="item.rank" @blur="setSorts(item.id,item.rank)">
					</van-grid-item>
				</van-grid>
			</van-cell>
		</van-list>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeKey: 0,
				storeFoodList: [],
				title: '',
				visible: false,
				batch: []
			}
		},
		mounted() {
			this.getStoreFoodList()
		},
		methods: {
			getStoreFoodList() {
				this.$http.post('/wechat/api.food_library/getStoreFoodList').then(response => {
					if (response && response.body.code == 200) {
						this.storeFoodList = response.body.data
					}
				})
			},

			setSorts(id, v) {
				this.batch=[{id: id,sort: v}]
				this.$http.post('/wechat/api.food_library/setSorts', {
					type: 'sortClass',
					batch: this.batch
				}).then(response => {
					if (response && response.body.code == 200) {
						this.getStoreFoodList()
					}
				})
			}

		}
	}
</script>


<style scoped="scoped">
	.van-grid-item{
	}
	.van-grid-item input{
		width: 1rem;
		text-align: center;
	}
</style>
